export default "__VITE_ASSET__6e8ab1c2__"